export const ageMethod = "age nearest";
export const gateway = "https://oraclerms-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/oraclerms";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJvcmFjbGVybXMiLCJuYW1lIjoib3JhY2xlcm1zIiwiaWF0IjoxNzc5OTI1NjY0LCJleHAiOjE5Mzc3MTM2NjR9.Rfc1lLPlHcfh02NKXeyNizXd1B4tr0bwYG9dFTodFvc";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"oraclerms.link.wawanesalife.com": {
		a: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_oraclerms",
			brands: [
				"oraclerms.link.wawanesalife.com",
			],
			broker: "oraclerms",
			broker_formatted_name: "Oracle RMS",
			email: "life@oraclerms.com",
			environment: "stable",
			environment_id: "stable",
			g4: "G-K79QEMGKPC",
			layout: "iframe",
			logoPosition: "menu",
			map1: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map2: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map3: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map4: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			"maps": {
				"map1": [
					"100 Drumlin Circle",
					"Concord",
					"ON",
					"L4K 3E5",
				],
			},
			menuPhone: "button",
			phone: "1-855-884-6150",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://www.oraclerms.com/privacy/",
			tagline: "Reduce Your Risk",
			themeSwitcher: "hide",
			website: "https://www.oraclerms.com/",
			scope: "oraclerms#branding#oraclerms.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "oraclerms.link.wawanesalife.com",
		},
		b: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_oraclerms",
			brands: [
				"oraclerms.link.wawanesalife.com",
			],
			broker: "oraclerms",
			broker_formatted_name: "Oracle RMS",
			email: "life@oraclerms.com",
			environment: "stable",
			environment_id: "stable",
			g4: "G-K79QEMGKPC",
			layout: "iframe",
			logoPosition: "menu",
			map1: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map2: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map3: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map4: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			"maps": {
				"map1": [
					"100 Drumlin Circle",
					"Concord",
					"ON",
					"L4K 3E5",
				],
			},
			menuPhone: "button",
			phone: "1-855-884-6150",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://www.oraclerms.com/privacy/",
			tagline: "Reduce Your Risk",
			themeSwitcher: "hide",
			website: "https://www.oraclerms.com/",
			scope: "oraclerms#branding#oraclerms.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "oraclerms.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 18:47:44 GMT-0500 (Central Daylight Time)
